/**
 * wrappingPaper — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const wrappingPaperPack: ToilePack = {
    slug: 'wrapping-paper',
    category: 'wrapping',
    name: 'Wrapping paper',
    tagline: tagline('patterns', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: SQUARE,
    readings: [
        {key: 'christmas', label: 'Christmas', subject: 'fir sprigs, baubles, candy canes, stars and boxes'},
        {key: 'birthday', label: 'Birthday', subject: 'balloons, party hats, confetti, candles and presents'},
        {key: 'wildflowers', label: 'Wildflowers', subject: 'poppies, cornflowers, daisies and wheat stems'},
    ],
    styles: [
        {key: 'handdrawn', label: 'Hand-drawn', style: 'loose ink outlines, color overshooting the line', palette: 'hand-filled on an off-white ground', framing: 'seamless repeat, edge to edge, tileable'},
        {key: 'geometric', label: 'Bold geometric', style: 'hard-edged flat shapes, high contrast', palette: 'a strict three-color saturated ground', framing: 'seamless repeat, edge to edge, tileable'},
        {key: 'gouache', label: 'Gouache', style: 'opaque brush marks, matte pigment', palette: 'soft dusty colors on a tinted ground', framing: 'seamless repeat, edge to edge, tileable'},
    ],
    directions: ['a baby shower theme', 'in kraft brown and white', 'a larger, sparser repeat'],
}
